import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomerAgeing, fetchVendorAgeing } from "./AgeingThunk";

const initialState = {
  // Customer ageing
  customerList: [],
  customerTotalBalance: 0,
  customerLoading: false,

  // Vendor ageing
  vendorList: [],
  vendorTotalBalance: 0,
  vendorLoading: false,

  // Shared filters
  filters: {
    reportType: "Customer", // "Customer" | "Vendor"
    customerId: null,
    supplierId: null,
    locationId: null,
    groupId: null,
  },
};

const ageingSlice = createSlice({
  name: "ageing",
  initialState,
  reducers: {
    setAgeingFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetAgeingFilters: () => initialState,
  },
  extraReducers: (builder) => {
    // Customer ageing
    builder
      .addCase(fetchCustomerAgeing.pending, (state) => {
        state.customerLoading = true;
      })
      .addCase(fetchCustomerAgeing.fulfilled, (state, action) => {
        state.customerLoading = false;
        state.customerList = action.payload.accounts || [];
        state.customerTotalBalance = action.payload.total_balance || 0;
      })
      .addCase(fetchCustomerAgeing.rejected, (state) => {
        state.customerLoading = false;
      });

    // Vendor ageing
    builder
      .addCase(fetchVendorAgeing.pending, (state) => {
        state.vendorLoading = true;
      })
      .addCase(fetchVendorAgeing.fulfilled, (state, action) => {
        state.vendorLoading = false;
        state.vendorList = action.payload.accounts || [];
        state.vendorTotalBalance = action.payload.total_balance || 0;
      })
      .addCase(fetchVendorAgeing.rejected, (state) => {
        state.vendorLoading = false;
      });
  },
});

export const { setAgeingFilters, resetAgeingFilters } = ageingSlice.actions;
export default ageingSlice.reducer;